module.exports = __webpack_public_path__ + "static/img/product_cp_3.88eb82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product_cp_3.png
// module id = MwNf
// module chunks = 1